<template>
  <div class="date_picker">
    <el-popover placement="bottom" width="313" trigger="click" v-model="visible" :disabled="disabled">
      <el-input
        slot="reference"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="16"
        readonly
        prefix-icon="el-icon-date"
        v-model="targetDate"
      >
        <i class="el-icon-circle-close" slot="suffix" v-show="clearable && targetDate !== ''" @click="clearDate"> </i>
      </el-input>

      <div class="picker_popover">
        <div class="calendar_header">
          <div style="width: 48%">
            <el-input
              v-model="selectedDate"
              placeholder="选择日期"
              @change="inspectValue"
              :readonly="readonly"
              :maxlength="10"
            ></el-input>
          </div>
          <div style="width: 48%">
            <el-time-select
              placeholder="选择时间"
              v-model="selectedTime"
              @change="e => datetimePicker(e)"
              :picker-options="pickerOptions"
            />
          </div>
          <div class="selected_time" v-if="false"></div>
        </div>

        <!-- 日历区域 -->
        <div class="calendar_container">
          <div class="year">
            <div>
              <span class="fl" @click="lastYear">«</span>
              <span class="fl" @click="lastMonth">‹</span>
              <p>{{ nowDate.year }}年{{ nowDate.month + 1 }}月</p>
              <span class="fr" @click="nextYear">»</span>
              <span class="fr" @click="nextMonth">›</span>
            </div>
          </div>
          <ul class="week">
            <li v-for="(o, index) in 7" :key="o">{{ formatWeek(index) }}</li>
          </ul>
          <ul class="date">
            <li @click="clickProv" class="none-week aaaa" v-for="o in lastMonthDays" :key="o + 50">
              <span>{{ lastMonthStartDay + o - 1 }}</span>
            </li>
            <li @click="clickEvent" v-for="day in nowMonthDays" :key="day">
              <span
                :class="`${
                  nowDate.year == onDate.year && nowDate.month == onDate.month && day == onDate.day ? 'onDate' : ''
                } ${
                  nowDate.year == onClick.year && nowDate.month == onClick.month - 1 && day == onClick.day
                    ? 'onClick'
                    : ''
                } ${
                  new Date(`${nowDate.year}-${nowDate.month + 1}-${day < 10 ? '0' + day : day}`).getTime() <
                    new Date(`${limitStartDate}`).getTime() ||
                  new Date(`${nowDate.year}-${nowDate.month + 1}-${day}`).getTime() > new Date(limitEndDate).getTime()
                    ? 'disabledTime'
                    : ''
                }`"
              >
                {{ day }}</span
              >
            </li>
            <li @click="clickNext" class="none-week" v-for="day in 42 - lastMonthDays - nowMonthDays" :key="day + 100">
              {{ day }}
            </li>
          </ul>
        </div>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="cancel">回今天</el-button>
        <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name:'DatePicker',
  props: {
    model: {
      type: String,
      default: ''
    },
    step: {
      // 间隔分钟
      type: String,
      default: '15'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '选择日期时间'
    },
    limitStartDate: {
      type: String,
      default: ''
    },
    limitEndDate: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      targetDate: '',
      selectedDate: '',
      selectedTime: '',
      visible: false,
      record: '',
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      /***  日历  ***/
      selectDate: [], //选择日期列表
      nowDate: this.getDate(new Date()), //当前设置时间 默认为当前系统时间
      onDate: {
        year: this.getDate(new Date()).year,
        month: this.getDate(new Date()).month,
        day: this.getDate(new Date()).date
      },
      onClick: {
        year: this.getDate(new Date()).year,
        month: this.getDate(new Date()).month + 1,
        day: this.getDate(new Date()).date
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler: function (n) {
        this.targetDate = n
      }
    },
    visible: function (n) {
      console.log(n , this.targetDate);
      
      if (n && this.targetDate !== '') {
        this.selectedDate = this.targetDate.split(' ')[0]
        this.selectedTime = this.targetDate.split(' ')[1] ? this.targetDate.split(' ')[1] : '00:00'
        this.nowDate = this.getDate(new Date(this.targetDate))
        this.clickEvent()
      }
      if (n && this.targetDate === '') {
        this.selectedDate = ''
        this.selectedTime = '00:00'
        this.nowDate = this.getDate(new Date())
        this.clickEvent()
      }
    },

    targetDate: function (n) {
      this.$emit('targetDate', this.targetDate) // 向外传值
    }
  },
  computed: {
    lastMonthDays() {
      return this.startWeek()
    },
    lastMonthStartDay() {
      return this.calcLastMonthDays(this.nowDate.year, this.nowDate.month) - (this.startWeek() - 1)
    },
    nowMonthDays() {
      return this.calcDays(this.nowDate.year, this.nowDate.month)
    }
  },
  created() {
    this.targetDate = this.model
    this.pickerOptions.step = `00:${this.step}`
    this.getDate(new Date())
  },
  methods: {
    clearDate() {
      setTimeout(() => {
        this.targetDate = ''
        this.selectedTime = ''
        this.selectedDate = ''
        this.nowDate = this.getDate(new Date())
      }, 10)
    },
    inspectValue(e) {
      console.log('inspectValue', e)
      let calc = ''
      // 时间为空值时
      if (e === '') return

      // 时间格式错误
      let reg = /^([1-9][0-9]{3})-([0-9]|[0-9]{2})-([0-9]|[0-9]{2})/
      if (!reg.test(e)) return this.$message({ type: 'error', message: '日期格式有误，请重新输入' })

      // 有值且时间格式正确
      let time = e.split('-')
      let y = time[0]
      let m = time[1]
      let d = time[2]

      // 处理自定义月份、年份
      if (m < 1) {
        y = Number(y) - 1
        m = 12
        calc = `${y}-${m}-${d}`
      } else if (m >= 12) {
        y = m > 12 ? Number(y) + Math.floor(m / 12) : y
        m = m % 12 ? m % 12 : this.nowDate.month + 1
        calc = `${y}-${m < 10 ? '0' + m : m}-${d}`
      } else {
        calc = `${y}-${m}-${d}`
      }
      // 自定义处理天数
      this.record = `${y}-${m}-1`
      calc = this.countDay(Number(d) - 1)
      this.nowDate = this.getDate(new Date(calc))
      this.clickEvent()
    },
    countDay(n) {
      // n为多少天，-代表往前，+代表往后
      let date1 = this.record === '' ? new Date() : new Date(this.record)
      let time1 = date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + 1 //time1表示当前时间
      let date2 = new Date(time1)
      date2.setDate(1 + n) // 从每个月1号开始算
      let time2 = `${date2.getFullYear()}-${('0' + (date2.getMonth() + 1)).slice(-2)}-${('0' + date2.getDate()).slice(
        -2
      )}`
      this.record = time2
      return time2
    },
    datetimePicker(e) {
      if (!e) this.selectedTime = ''
      if (this.selectedDate === '') this.selectedDate = `${this.onClick.year}-${this.onClick.month}-${this.onClick.day}`
      this.targetDate = `${this.selectedDate} ${this.selectedTime}`
    },
    cancel() {
      this.nowDate = this.getDate(new Date())
      this.clickEvent()
    },
    /***   日历的事件  ***/
    getDate(date) {
      return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDay(),
        date: date.getDate()
      }
    },
    formatWeek(day) {
      switch (day) {
        case 0:
          return '日'
        case 1:
          return '一'
        case 2:
          return '二'
        case 3:
          return '三'
        case 4:
          return '四'
        case 5:
          return '五'
        case 6:
          return '六'
      }
    },
    clickEvent(e) {
      let monthNo = this.nowDate.month
      let month = monthNo <= 11 ? monthNo + 1 : 0
      let innerText = e ? e.target.innerText : this.nowDate.date
      let date = {
        year: this.nowDate.year,
        month: month < 10 ? '0' + month : month,
        week: new Date(this.nowDate.year, innerText).getDay(),
        day: Number(innerText) < 10 ? '0' + Number(innerText) : Number(innerText)
      }

      // 禁止选择限制日期前的日期
      let time = `${date.year}-${date.month}-${date.day}`

      let isStartDate = new Date(time).getTime() < new Date(this.limitStartDate).getTime()
      let isEndDate = new Date(time).getTime() > new Date(this.limitEndDate).getTime()
      if (isStartDate || isEndDate) return

      // 赋值选中的日期
      this.onClick = date
      if (e && !this.selectedTime) this.selectedTime = '00:00'
      this.selectedDate = `${date.year}-${date.month}-${date.day}`
      this.targetDate = `${this.selectedDate} ${this.selectedTime}`
    },
    clickProv(e) {
      this.lastMonth()
      this.clickEvent(e)
    },
    clickNext(e) {
      this.nextMonth()
      this.clickEvent(e)
    },
    //判断闰年
    isLeapYear(year) {
      return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)
    },
    //根据日子计算星期
    calcWeekend(year, month, day) {
      return new Date(year, month, day).getDay()
    },
    //计算某年某月的天数
    calcDays(year, month) {
      const monthDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      if (this.isLeapYear(year) && month === 1) return 29
      else return monthDay[month]
    },
    //计算上个月天数
    calcLastMonthDays(year, month) {
      if (month === 0) {
        return this.calcDays(year - 1, 11)
      } else {
        return this.calcDays(year, month - 1)
      }
    },
    //上月
    lastMonth() {
      if (this.nowDate.month === 0) {
        this.nowDate.month = 11
        this.nowDate.year--
      } else {
        this.nowDate.month--
      }
    },
    //下月
    nextMonth() {
      if (this.nowDate.month === 11) {
        this.nowDate.month = 0
        this.nowDate.year++
      } else {
        this.nowDate.month++
      }
    },
    //去年
    lastYear() {
      this.nowDate.year--
    },
    //下一年
    nextYear() {
      this.nowDate.year++
    },
    //计算当月开始星期
    startWeek() {
      return this.calcWeekend(this.nowDate.year, this.nowDate.month, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.date_picker {
  width: 100%;
  height: 31px;
}
::v-deep .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
::v-deep .el-input__validateIcon {
  display: none;
}
::v-deep .el-input {
  width: 100%;
  height: 100%;
}
.picker_popover {
  width: 100%;
  height: 367px;
  margin-bottom: 5px;
  border-bottom: 1px solid #e6e6e6;
  .calendar_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    ::v-deep .el-date-editor {
      width: 100% !important;
    }

    ::v-deep .el-input__inner {
      width: 100%;
      height: 30px !important;
      padding: 0 15px !important;
    }
    ::v-deep .el-input__prefix {
      display: none;
    }
  }
  .calendar_container {
    color: #6a6c70;
    border-top: 1px solid #e6e6e6;
    margin-top: 7px;
    .year {
      text-align: center;
      height: 30px;
      line-height: 30px;
      margin: 5px 0 12px;
      font-size: 12px;
    }
    .week,
    .date {
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
    }
    .week {
      border-bottom: 1px solid #e6e6e6;
      //   background: #f4f4f4;
    }
    .week li {
      height: 41px;
      line-height: 41px;
    }
    .date li {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 25px;
      height: 37px;
      padding: 3px 0;
      box-sizing: border-box;
    }
    .date li span {
      display: block;
      height: 25px;
    }
    .date li .onDate {
      color: #0000ff;
      height: 25px;
    }
    .date li .onClick {
      background: #409eff;
      border-radius: 50%;
      color: #fff;
      width: 25px;
      height: 25px;
    }

    .date .disabledTime {
      color: #ccc;
      cursor: no-drop;
      width: 100%;
      background-color: #f1f1f1;
    }

    ul > li {
      font-size: 12px;
      width: calc(100% / 7);
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
    .none-week {
      color: #ccc;
    }
    .year > div {
      height: 30px;
      overflow: hidden;
    }
    .year span {
      line-height: 27px;
      font-size: 20px;
      display: inline-block;
      width: 10%;
      cursor: pointer;
    }
    .year p {
      width: 50%;
      display: inline-block;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
  }
}
</style>
